import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../config/firebase';
import { collection, getDocs } from 'firebase/firestore';

export default function StudentLabs() {
  const navigate = useNavigate();
  const [currentWeek, setCurrentWeek] = useState(1);
  const [filterGroup, setFilterGroup] = useState('all');
  const [labStatuses, setLabStatuses] = useState({});
  
  const groups = ['Alpha', 'Beta', 'Charlie', 'Delta', 'Echo'];
  
  const [labs] = useState([
    // Week 1
    { id: 1, week: 1, group: 'Alpha', title: 'Foundation Concepts - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdTt0mAxUmhIcUnhqfyuMQslMPfCq1pHEsJ0KMDUnecpDMkIA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 2, week: 1, group: 'Beta', title: 'Foundation Concepts - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevWdz-eKrsGTgKct1qIIaJzlvGBdJREDG_T_5y1vq3fkzUow/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 3, week: 1, group: 'Charlie', title: 'Foundation Concepts - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScNphURm1i-JXTdaQys8e66phsNGqYihalfyF6Bq1uCGgQSfw/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    // Week 2
    { id: 4, week: 2, group: 'Alpha', title: 'Intermediate Topics - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSc6hM4TOdOLYXtNSTsI-wYIwoyLanUTNOHJq-pZChicuZfsVA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 5, week: 2, group: 'Beta', title: 'Intermediate Topics - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeuhvjduiGD4sNZGEKNmeApdv5BfnCJyAoIx_c5k3URH8eBxA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 6, week: 2, group: 'Charlie', title: 'Intermediate Topics - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSePd4Z3SxoSfcdo-Oln49gNfu6xjwGdP3becWaEcIQnew1RUw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 3
    { id: 7, week: 3, group: 'Alpha', title: 'Advanced Techniques - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSegvV7vlqZrdN7riuDIl59ljBDqxteCRJfkIjOFICGfT9vfVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 8, week: 3, group: 'Beta', title: 'Advanced Techniques - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf1YpZGzqeYtWfQBYwVwHhkj3iIE7tqCySIHYiqZejQn-Vq7g/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 9, week: 3, group: 'Charlie', title: 'Advanced Techniques - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSegvV7vlqZrdN7riuDIl59ljBDqxteCRJfkIjOFICGfT9vfVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 4
    { id: 10, week: 4, group: 'Alpha', title: 'Week 4 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfwNM2emEWz8V6HakptBiKj3KcIlCJY1CaGb9QvaDeBblg0qA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 11, week: 4, group: 'Beta', title: 'Week 4 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSck2nLDk85QhYE71AdWB7u1bGTZ3Dx7eR2_FDohv6aZgs3nbg/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 12, week: 4, group: 'Charlie', title: 'Week 4 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfrPN6HX4_Yy-qaW5ourBqHTCaelnWj_3EsbUa4Q3RydVBHGA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 5
    { id: 13, week: 5, group: 'Alpha', title: 'Week 5 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScpjZCuEWVjY4BZEEbqt-GpVVyB5jsD_TxHj83zGydpu69-SQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 14, week: 5, group: 'Beta', title: 'Week 5 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevTLNe4xdZJHAAayRWLTTVYqwMgZjfn7qDdUFodwwF-sqAfA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 15, week: 5, group: 'Charlie', title: 'Week 5 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSe1_47PjcAj7Qu_qXCifc4p7ROPE5hwpcG_vU2dgIZdO9d-Qw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 6
    { id: 16, week: 6, group: 'Alpha', title: 'Week 6 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSejALLygBRNLX30MoncimumzIzk3XEX5-JT8oYzQbslGwsNUA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 17, week: 6, group: 'Beta', title: 'Week 6 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdAT-nCeh3cU84JHYFrruNdD4pHZW4itUELFeYOAXHTfwkrkA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 18, week: 6, group: 'Charlie', title: 'Week 6 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSedfcf3AWmzMCpvMkLPjjQO_DPA408xU1KNZaqxIBhzh3BIOA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 7
    { id: 19, week: 7, group: 'Alpha', title: 'Week 7 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfWEjZWBg0d-AY-sRJV0rgy4XhykU7LR5XpXFHWDFJ0Ckr8VQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 20, week: 7, group: 'Beta', title: 'Week 7 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf9zrVmBT1zxs0ddSrtxbO7nb-0LskFoukBSIKH3SurORdvlQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 21, week: 7, group: 'Charlie', title: 'Week 7 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScr-G7vMhZPihWBhNxe7DJOuax5i_8yl1f33EVQxBxchTg-Fw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 8
    { id: 22, week: 8, group: 'Alpha', title: 'Week 8 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdwDy0ehO93323SjBhVJWcbAbm-ILXILQbz-CPURslXJwd0Dw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 23, week: 8, group: 'Beta', title: 'Week 8 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdB1F2kw-L23KxCvMqkpdmFb3ZsUlVepdt1Nnyi62UJmZjtKQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 24, week: 8, group: 'Charlie', title: 'Week 8 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevgBY55j1psbzxJ9rshwGfH-ZQa2Usgmvte2_k__r7nYcjwA/viewform?usp=publish-editor', status: 'closed' },
    // Week 9
    { id: 25, week: 9, group: 'Alpha', title: 'Week 9 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdbckIRpPU9gdne7yZC3MEAMfTxjaXUXIQemCGNjDGwG0ycdg/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 26, week: 9, group: 'Beta', title: 'Week 9 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScsWFEU5VCiE6aQTfgCQNK73K-INg_REzhjMRrmeTsR1mjciA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 27, week: 9, group: 'Charlie', title: 'Week 9 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdaBIIbJxAFSCdUW-d_Q1EmBmIFrscEe89fo3h7rMkRRYDvug/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 1 - Delta
    { id: 28, week: 1, group: 'Delta', title: 'Foundation Concepts - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdQxJ2jZ99U3P4WjrezVnwwA9Q6RcbZxikYJikfUw7DqznFVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 2 - Delta
    { id: 29, week: 2, group: 'Delta', title: 'Intermediate Topics - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfno0zW3qVANyeJFfKB2FF5lW1XNZ-VZomYPRxjTw7ekG9HmA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 3 - Delta
    { id: 30, week: 3, group: 'Delta', title: 'Advanced Techniques - Delta', pdfUrl: 'https://docs.google.com/forms/d/1EzLqORopaJ7rLQZBhbTTObNBV-gDBCGRoAa8LpMaVLI/edit', status: 'closed' },
    // Week 4 - Delta
    { id: 31, week: 4, group: 'Delta', title: 'Week 4 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeNHPtj1IO19pFk1r7vtL3jI3zpPfqm8iiJpAvJuIFNAj8CWw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 5 - Delta
    { id: 32, week: 5, group: 'Delta', title: 'Week 5 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSetyeifdAbPF8pIhFGK3rJ6nKsnEy_GfN4oUWN57I-NOz7YAw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 6 - Delta
    { id: 33, week: 6, group: 'Delta', title: 'Week 6 - Delta', pdfUrl: 'https://docs.google.com/forms/d/1M-4KoDyZIGai0p77vPgVxOzHG5zPoBqpiAwDUXQzMIM/edit', status: 'closed' },
    // Week 7 - Delta
    { id: 34, week: 7, group: 'Delta', title: 'Week 7 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfHjma9_-peL0m8tGOViiF8-sbGxAnO7cDBK7PQv_7kXH9r7Q/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 8 - Delta
    { id: 35, week: 8, group: 'Delta', title: 'Week 8 - Delta', pdfUrl: 'https://docs.google.com/forms/d/1Ocihn9wy1VLy_MJhBLHxRIYHry597DryY6ERl8GxOvA/edit', status: 'closed' },
    // Week 1 - Echo (placeholder - no data)
    { id: 36, week: 1, group: 'Echo', title: 'Foundation Concepts - Echo', pdfUrl: '', status: 'closed' },
    // Week 2 - Echo
    { id: 37, week: 2, group: 'Echo', title: 'Intermediate Topics - Echo', pdfUrl: '', status: 'closed' },
    // Week 3 - Echo
    { id: 38, week: 3, group: 'Echo', title: 'Advanced Techniques - Echo', pdfUrl: '', status: 'closed' },
    // Week 4 - Echo
    { id: 39, week: 4, group: 'Echo', title: 'Week 4 - Echo', pdfUrl: '', status: 'closed' },
    // Week 5 - Echo
    { id: 40, week: 5, group: 'Echo', title: 'Week 5 - Echo', pdfUrl: '', status: 'closed' },
    // Week 6 - Echo
    { id: 41, week: 6, group: 'Echo', title: 'Week 6 - Echo', pdfUrl: '', status: 'closed' },
    // Week 7 - Echo
    { id: 42, week: 7, group: 'Echo', title: 'Week 7 - Echo', pdfUrl: '', status: 'closed' },
    // Week 8 - Echo
    { id: 43, week: 8, group: 'Echo', title: 'Week 8 - Echo', pdfUrl: '', status: 'closed' }
  ]);
  
  const weeks = [...new Set(labs.map(lab => lab.week))].sort((a, b) => a - b);

  // Load lab statuses from Firestore
  useEffect(() => {
    const loadLabStatuses = async () => {
      try {
        const instructorsRef = collection(db, 'instructors');
        const queryResult = await getDocs(instructorsRef);
        
        let allStatuses = {};
        for (const instructorDoc of queryResult.docs) {
          try {
            const statusCollectionRef = collection(db, 'instructors', instructorDoc.id, 'labStatuses');
            const statusDocs = await getDocs(statusCollectionRef);
            
            for (const statusDoc of statusDocs.docs) {
              const statuses = statusDoc.data();
              // statuses contains lab_1: 'released', lab_2: 'closed', etc.
              Object.assign(allStatuses, statuses);
            }
          } catch (error) {
            console.log('Could not load lab statuses for instructor:', instructorDoc.id);
          }
        }
        
        console.log('[StudentLabs] Loaded lab statuses from Firestore:', allStatuses);
        setLabStatuses(allStatuses);
      } catch (error) {
        console.error('Error loading lab statuses:', error);
      }
    };
    
    loadLabStatuses();
  }, []);

  const takeLab = (lab) => {
    navigate(`/take-lab/${lab.id}`, { state: { lab } });
  };
  
  // Get labs for current week
  const weekLabs = labs.filter(lab => lab.week === currentWeek);
  
  // Filter by group AND only show released labs
  const filteredLabs = (filterGroup === 'all' 
    ? weekLabs 
    : weekLabs.filter(lab => lab.group === filterGroup))
    .filter(lab => labStatuses[`lab_${lab.id}`] === 'released');

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: '#1a1a1a',
              border: 'none',
              color: 'white',
              padding: '0.6rem 0.8rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 300ms ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2d2d2d';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#1a1a1a';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
              <i className="fas fa-calendar-alt" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
              Weekly Labs
            </h1>
            <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
              Access and complete all weekly lab assignments
            </p>
          </div>
        </div>

        {/* Week Selector and Filter */}
        <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          {/* Week Selector */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1rem' }}>Select Week:</label>
            <select 
              value={currentWeek} 
              onChange={(e) => setCurrentWeek(parseInt(e.target.value))}
              style={{
                padding: '0.75rem 1rem',
                border: '1px solid #e8e8e8',
                borderRadius: '6px',
                fontFamily: 'inherit',
                fontSize: '1rem',
                background: 'white',
                color: '#1a1a1a',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 300ms ease'
              }}
            >
              {weeks.map(week => (
                <option key={week} value={week}>Week {week} ({labs.filter(l => l.week === week).length} labs)</option>
              ))}
            </select>
          </div>

          {/* Filter by Group */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1rem' }}>Filter by Group:</label>
            <select 
              value={filterGroup} 
              onChange={(e) => setFilterGroup(e.target.value)}
              style={{
                padding: '0.75rem 1rem',
                border: '1px solid #e8e8e8',
                borderRadius: '6px',
                fontFamily: 'inherit',
                fontSize: '1rem',
                background: 'white',
                color: '#1a1a1a',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 300ms ease'
              }}
            >
              <option value="all">All Groups</option>
              {groups.map(group => (
                <option key={group} value={group}>{group}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Labs List */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem' }}>
          {filteredLabs.length === 0 ? (
            <div style={{
              background: '#f9f9f9',
              border: '2px dashed #e8e8e8',
              borderRadius: '8px',
              padding: '3rem',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>
                {weekLabs.length === 0 
                  ? 'No labs found for this week and group combination.' 
                  : 'The instructor has not released any labs for this week and group yet. Check back soon!'}
              </p>
            </div>
          ) : (
            filteredLabs
              .sort((a, b) => groups.indexOf(a.group) - groups.indexOf(b.group))
              .map(lab => (
                <div
                  key={lab.id}
                  style={{
                    background: '#dcdcdc',
                    border: '1px solid #c0c0c0',
                    borderRadius: '8px',
                    padding: '1rem',
                    transition: 'all 300ms ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '2rem', alignItems: 'start' }}>
                    <div>
                      <h3 style={{ fontWeight: 700, margin: '0 0 1rem 0', color: '#1a1a1a', fontSize: '1.25rem' }}>
                        {lab.title}
                      </h3>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <span style={{ color: '#666', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <i className="fas fa-layer-group"></i>
                          Week {lab.week} - {lab.group}
                        </span>
                        <span style={{
                          background: labStatuses[`lab_${lab.id}`] === 'released' ? '#e8f5e9' : '#ffebee',
                          color: labStatuses[`lab_${lab.id}`] === 'released' ? '#2e7d32' : '#c62828',
                          padding: '0.5rem 1rem',
                          borderRadius: '20px',
                          fontSize: '0.9rem',
                          fontWeight: 600
                        }}>
                          {labStatuses[`lab_${lab.id}`] === 'released' ? '● Available' : '● Locked'}
                        </span>
                      </div>
                    </div>

                    <div style={{ minWidth: '150px' }}>
                      <button
                        onClick={() => takeLab(lab)}
                        disabled={labStatuses[`lab_${lab.id}`] !== 'released'}
                        style={{
                          width: '100%',
                          background: labStatuses[`lab_${lab.id}`] === 'released' ? '#1a1a1a' : '#e8e8e8',
                          color: labStatuses[`lab_${lab.id}`] === 'released' ? 'white' : '#999',
                          border: 'none',
                          padding: '0.75rem 1.5rem',
                          borderRadius: '6px',
                          fontWeight: 600,
                          cursor: labStatuses[`lab_${lab.id}`] === 'released' ? 'pointer' : 'not-allowed',
                          fontSize: '1rem',
                          transition: 'all 300ms ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '0.5rem'
                        }}
                        onMouseOver={(e) => {
                          if (labStatuses[`lab_${lab.id}`] === 'released') {
                            e.target.style.background = '#7A5107';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (labStatuses[`lab_${lab.id}`] === 'released') {
                            e.target.style.background = '#1a1a1a';
                          }
                        }}
                      >
                        <i className="fas fa-edit"></i>
                        Take Lab
                      </button>
                    </div>
                  </div>
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  );
}
